import { ConnectMenusa } from 'entities/application/constants/applications/Menusa/ConnectMenusa/ConnectMenusa';
import { MenusaInstruction_eng } from 'entities/application/constants/applications/Menusa/MenusaInstruction';
import { ApplicationWithDetails } from '../../../types';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const Menusa_eng: ApplicationWithDetails = {
	id: `2659AAE181454A358EC58E6A4969399A`,
	name: `Menusa`,
	description: `QR Menu for your restaurants`,
	descriptionLong: `Replace the printed menu in the restaurant with an online menu via a QR code. Now there's no need to reprint the menu when it's updated. It's convenient, cost-effective, and always at hand. Download the unique QR code, print it, and place it in the restaurant. Your guests can scan the code to instantly view the menu in the browser—without the need to download an app.\n\nQR menu is available only for units in Russia..`,
	logoUrl: `https://cdn.dodostatic.net/static/marketplace/menusa/logo`,
	sliders: [
		// eslint-disable-next-line sonarjs/no-duplicate-string
		`https://cdn.dodostatic.net/static/marketplace/menusa/slider-en`,
	],
	logoBgr: `https://cdn.dodostatic.net/static/marketplace/menusa/bgr`,
	conceptions: [`Dodo Pizza`],
	webSiteUrl: `https://menusa.app/`,
	supportUrl: null,
	redirectUrl: ``,
	contactEmail: `info@menusa.app`,
	supportEmail: ``,
	type: `Web`,
	categories: [`Menu`, `QR-menu`, `Restaurant`, `Clients`],
	countries: [`All`],
	languages: [`Русский`],
	price: `Free`,
	version: `1.0`,
	developer: `Menusa`,
	plans: null,
	instructions: MenusaInstruction_eng,
	details: null,
	knowledgeBase: null,
	showInstruction: false,
	versionHistory: null,
	isExternal: false,
	goToApp: true,
	hasAdditionalFlow: ConnectMenusa,
};
